// Where a file menu's project opens inside Pro: the Library's own files in Pro's frame, with the
// project open (spec ui-perf/ui-switch-classic-simple-pro, PR e3 and the #1476 review). One link
// for every Pro page that draws a file menu, so they never drift.
import { Link } from "@tanstack/react-router";
import { useCallback } from "react";

import type { ProjectLink } from "../platform/media/project-link";

/** `pro/library/files?folder=`, under the brand Pro is on. */
export function useProProjectLink(teamId: string, brandId: string): ProjectLink {
  return useCallback<ProjectLink>(
    (props, folder) => (
      <Link
        {...props}
        to="/teams/$teamId/brands/$brandId/pro/library/files"
        params={{ teamId, brandId }}
        search={{ folder }}
      />
    ),
    [teamId, brandId],
  );
}
